// ---------------------------------------------------------------------------
// Edge-crossing telegraph (seamless map edges): a soft top-center pill —
// "→ East Marches" — shown while the player stands in the approach band of a
// LINKED map edge, so the world swap is named and expected before the server
// trigger fires. #toast's idiom (class-toggled opacity/translate transition),
// but persistent: visible while in the band, no auto-timeout.
// Driven per frame by src/edge/preview.ts.
// ---------------------------------------------------------------------------

let el: HTMLElement | null = null;

export function initEdgeCue(): void {
  el = document.getElementById("edgecue");
}

export function showEdgeCue(text: string): void {
  if (!el) return;
  if (el.textContent !== text) el.textContent = text;
  el.classList.add("show");
}

export function hideEdgeCue(): void {
  el?.classList.remove("show");
}
